import React, { useCallback } from 'react'
import context from '@/context'
import { Main, MainTop, MainBody, WhiteBox, BoxHeader } from '@/components/Layout'
import { FormLoader, FormRow } from '@/components/changeRequests'
import { ChangeItemFileAttachments } from '@/components/changeRequests/fileAttachments'
import { ValidationBoundary } from '@/components/validation'
import { Row, Col } from 'reactstrap'
import { PersonSelection } from '@/components/demographics/personSelection'
import { ValidDates } from '@/components/changeRequests/common/validDates'
import { ScopeDetailHeader } from '@/components/changeRequests/scopeDetailHeader'
import { useLocalization } from '@/hooks/localization'
import { usePropertyReader } from '@/hooks/usePropertyReader'

function BlacklistDetail ({ match }) {
  return (
    <FormLoader match={match} loader={context.api.blacklistRecordService.get} render={(formProps) => <BlacklistDetailPage {...formProps} />} />
  )
}
const BlacklistDetailForm = ({ targetId, readonly, target }) => {
  const { localize } = useLocalization()
  const getAttachmentsTableData = useCallback((req) => context.api.blacklistRecordService.getAttachmentsTableData(targetId, req), [targetId])
  const [validFrom, penaltyExtended] = usePropertyReader(['validFrom', 'penaltyExtended'])
  const extensionDateValidate = useCallback(x => x.value && validFrom && x.value < validFrom && 'Validations.InvalidExtensionDate', [validFrom])

  return (
    <React.Fragment>
      <Row>
        <Col lg={6}>
          <FormRow label='Blacklists.Type' name='blacklist' inputType='lookup' readonly={readonly} dataSource={context.cache.getBlacklists} clientSide isCodeList required />
          <PersonSelection required readonly={readonly} />
          <ValidDates validFromRequired readonly={readonly} />
          <FormRow
            label='CodeLists.PenaltySource'
            name='penaltySource'
            inputType='lookup'
            dataSource={context.cache.getPenaltySources}
            clientSide
            isCodeList
          />
          <FormRow
            label='Blacklists.PenaltyExtended'
            name='penaltyExtended'
            inputType='checkbox'
          />
          {penaltyExtended && (<FormRow
            label='Blacklists.ExtensionDate'
            name='penaltyExtensionDate'
            inputType='date'
            onValidate={extensionDateValidate}
          />)}
        </Col>
        <Col lg={6}>
          <FormRow label='Common.Reason' name='reason' inputType='textarea' readonly={readonly} />
          <FormRow label='Common.Description' name='description' inputType='textarea' readonly={readonly} />
          <FormRow label='Common.Number' name='number' inputType='textarea' readonly={readonly} />
          <FormRow label='Common.CancelNumber' name='cancelNumber' inputType='textarea' readonly={readonly} />
          <FormRow label='Common.CancelReason' name='cancelReason' inputType='textarea' readonly={readonly} />
        </Col>
      </Row>
      <BoxHeader className='header'>{localize('Common.Attachments')}</BoxHeader>
      <ChangeItemFileAttachments
        target={target}
        name='attachments'
        dataSource={getAttachmentsTableData}
        downloadAction={context.api.blacklistRecordService.download}
        simpleView
        attachmentsView readonly={readonly} />
    </React.Fragment>
  )
}
const BlacklistDetailPage = React.memo(function BlacklistDetailPage (props) {
  const { targetId } = props
  return (
    <Main>
      <MainTop>
        <ScopeDetailHeader title='Blacklists.BlacklistDetailTitle' backUrl='/blacklists' />
      </MainTop>
      <MainBody transparent>
        <ValidationBoundary>
          <WhiteBox>
            <BlacklistDetailForm targetId={targetId} />
          </WhiteBox>
        </ValidationBoundary>
      </MainBody>
    </Main>
  )
})

export {
  BlacklistDetail,
  BlacklistDetailForm
}



// WEBPACK FOOTER //
// ./src/internal-app/pages/blackLists/detail.js